var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"activity","data-is-lesson":_vm.isLesson}},[(_vm.getActivityComponent)?_c(_vm.getActivityComponent,{key:_vm.getActivity.id,tag:"component",attrs:{"isPreview":_vm.isPreview}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }